import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const coverageSourceTypeList = (params = '') => Http.get(`/coverage-source-types${serialize(params)}`)
export const coverageSourceTypeCreate = (params = '') => Http.post('/coverage-source-types', params)
export const coverageSourceTypeByID = (params = '') => Http.get(`/coverage-source-types/${params}`)
export const coverageSourceTypeUpdate = (params = '') => Http.put(`/coverage-source-types/${params.id}`, params)
export const coverageSourceTypeDestroy = (params = '') => Http.delete(`/coverage-source-types/${params.id}`)
